import React, { useState } from "react";
import { Row, Col, Card, CardBody, Spinner, Badge } from "reactstrap";
import { useTranslation } from "react-i18next";
import SponsorSourceDividedValueChart from "../components/SponsorSourceDividedValueChart";
import OverallMetric from "../components/OverallMetric";
import SponsorObjectTabs from "../components/SponsorObjectTabs";
import SponsorLogoStatsChart from "../components/SponsorLogoStatsChart";
import LogoDetectionStatsChart from "../components/LogoDetectionStatsChart";
import { connect } from "react-redux";
import LineGraph from "../components/LineGraph";
import {
  useSponsorReach,
  useSponsorValue,
  useSponsorDividedReach,
  useSponsorDividedValue,
  useSponsorStationDividedValue,
  useSponsorValueDividedYear,
  useSponsorContractCategoryDivded,
  useSponsorPerformanceBubble,
  useSocialAccounts,
  useSponsorDividedEngagement,
  useSponsorDividedEngagementValue,
} from "../query/hooks";
import useSponsorMediaValue from "../query/hooks/useSponsorMediaValue";
import useSponsorEngagementValue from "../query/hooks/useSponsorEngagementValue";
import BarGraph from "../components/BarGraph";
import useSponsorTvDiveded from "../query/hooks/useSponsorTvDiveded";
import SummaryDonutChart from "../components/SummaryDonutChart";
import ROIWidget from "../components/ROIWidget";
import PieChart from "../components/PieChart";
import Table from "../components/Table";
import useSponsorPerformanceTable from "../query/hooks/useSponsorPerformanceTable";
import BubbleGraph from "../components/BubbleGraph";
import useSponsorImageDetectionExample from "../query/hooks/useSponsorImageDetectionExample";
import ImageDetectionGrid from "../components/ImageDetectionGrid";
import InfoTooltip from "../components/InfoTooltip";
import BestSocialMediaPostBubbles from "../components/BestSocialMediaPostBubbles";
import PerformingSocialMediaPosts from "../components/PerformingSocialMediaPosts";
import PerformingSocialMediaMentions from "../components/PerformingSocialMediaMentions";
import PerformingSocialMediaTagged from "../components/PerformingSocialMediaTagged";
import TrackedAccountPosts from "../components/TrackedAccountPosts";
// import MediaValueSummaryCards from "../components/MediaValueSummaryCards";
// import { useMediaValueTimeline, useMediaValueByEvent } from "../query/hooks";

const DashboardSponsor = ({ selectedCurrency, tenant }) => {
  const { t } = useTranslation();
  const [params, setParams] = useState({ sponsorObjectId: 0 });
  const imageDetection = useSponsorImageDetectionExample(params.sponsorObjectId);
  const { hasActiveSocialAccounts } = useSocialAccounts();
  const trackedAccountsEnabled = !!tenant?.features?.['tracked-accounts'];
  // With tracked-accounts the API replaces own Facebook and Instagram with Earned and
  // Tracked (as on DashboardSponsorPA); without it every request is unchanged.
  const metricParams = trackedAccountsEnabled ? { ...params, tracked: 1 } : params;
  const graphParams = [params.sponsorObjectId, trackedAccountsEnabled];

  const onClickTab = (tabIndex, newSponsorObjectId) => {
    setParams((prev) => ({ ...prev, sponsorObjectId: newSponsorObjectId }));
  };
  var hideTabs = false;
  var showLogoDetection = false;
  if (tenant.name === "Bama") {
    hideTabs = true;
  }
  if (tenant.name === "KPMG") {
    showLogoDetection = true;
  }
  return (
    <>
      <div className="container-fluid pt- mt-3">
        {hideTabs ? null : <SponsorObjectTabs onClickTab={onClickTab} />}
        <Row className="mb-4">
          <Col xl={3} md={6} className="mb-4 mb-xl-0">
            <OverallMetric
              followCalender
              isCurrency
              metric="sponsor-value"
              params={metricParams}
              append=""
            />
          </Col>
          <Col xl={3} md={6} className="mb-4 mb-xl-0">
            <OverallMetric
              followCalender
              metric="sponsor-exposures"
              params={metricParams}
            />
          </Col>
          <Col xl={3} md={6} className="mb-4 mb-xl-0">
            <OverallMetric
              followCalender
              metric="sponsor-reach"
              params={metricParams}
              append=""
            />
          </Col>
          <Col xl={3} md={6} className="mb-4 mb-xl-0">
            <OverallMetric
              followCalender
              metric="sponsor-time"
              params={params}
              append="min"
            />
          </Col>
        </Row>
        {trackedAccountsEnabled && (
          <Row className="mb-4" style={{ height: 400 }}>
            <Col sm={12} md={6} className="mb-4 mb-xl-0 h-100">
              <Card className="mini-stat bg-card text-white h-100">
                <CardBody style={{ paddingBottom: '1.5rem' }}>
                  <h4 className="card-title mb-4">
                    {t("media_value_title")}
                    <InfoTooltip tooltip={t("media_value_tooltip")} />
                  </h4>
                  <SummaryDonutChart useQuery={useSponsorMediaValue} queryParams={{ sponsorObjectId: params.sponsorObjectId }} />
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-4 mb-xl-0 h-100">
              <Card className="mini-stat bg-card text-white h-100">
                <CardBody style={{ paddingBottom: '1.5rem' }}>
                  <h4 className="card-title mb-4">
                    {t("engagement_value_title")}
                    <InfoTooltip tooltip={t("engagement_value_tooltip")} />
                  </h4>
                  <SummaryDonutChart useQuery={useSponsorEngagementValue} queryParams={{ sponsorObjectId: params.sponsorObjectId }} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        <Row className="mb-4">
          <Col sm={12} md={trackedAccountsEnabled ? 6 : (params.sponsorObjectId === 0 ? 3 : 6)} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white h-100" style={{minHeight: 400}}>
              <CardBody className="d-flex flex-column">
                <h4 className="card-title mb-4">{t("ROI")}</h4>
                <ROIWidget sponsorObjectId={params.sponsorObjectId} tracked={trackedAccountsEnabled} />
              </CardBody>
            </Card>
          </Col>
          {params.sponsorObjectId === 0 && (
            <Col sm={12} md={trackedAccountsEnabled ? 6 : 3} className="mb-4 mb-xl-0">
              <Card className="mini-stat bg-card text-white" style={{minHeight: 400}}>
                <CardBody>
                  <h4 className="card-title mb-4">{t("Category Investment")}</h4>
                  <PieChart useQuery={useSponsorContractCategoryDivded} params={[params.sponsorObjectId]} />
                </CardBody>
              </Card>
            </Col>
          )}
          {!trackedAccountsEnabled && (
            <Col sm={12} md={6} className="mb-4 mb-xl-0">
              <Card className="mini-stat bg-card text-white" style={{minHeight: 400}}>
                <CardBody>
                  <h4 className="card-title mb-4">{t("Value")}</h4>
                  <SummaryDonutChart useQuery={useSponsorValueDividedYear} queryParams={{sponsorObjectId: params.sponsorObjectId}} />
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
        {/* With tracked-accounts, platform performance shows only when the tenant has social platforms configured */}
        {params.sponsorObjectId === 0 && (!trackedAccountsEnabled || hasActiveSocialAccounts) && (
          <Row className="mb-4">
            <Col sm={12} md={6} className="mb-4 mb-xl-0">
              <Card className="mini-stat bg-card text-white h-100">
                <CardBody>
                  <h4 className="card-title mb-4">{t("Platform Performance")}</h4>
                  <Table
                    useQuery={useSponsorPerformanceTable}
                    params={[params.sponsorObjectId]}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-4 mb-xl-0">
              <Card className="mini-stat bg-card text-white">
                <CardBody>
                  <h4 className="card-title mb-4">{t("Platform Performance Index")}</h4>
                  <BubbleGraph
                    useQuery={useSponsorPerformanceBubble}
                    params={[params.sponsorObjectId]}
                    xLabel="Engagements"
                    yLabel="Impressions"
                    zLabel="Value"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {/* Media Value Section (ClickHouse-based) */}
        {/* <MediaValueSummaryCards sponsorObjectId={params.sponsorObjectId} /> */}

        {/* <Row className="mb-4">
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Media Value Timeline")} ({selectedCurrency.currency})
                </h4>
                <LineGraph
                  useGraphQuery={useMediaValueTimeline}
                  queryParams={[params.sponsorObjectId]}
                  defaultActiveTab={0}
                  noTabs
                />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">{t("Value by Event")}</h4>
                <BarGraph
                  useGraphQuery={useMediaValueByEvent}
                  queryParams={[params.sponsorObjectId]}
                  scrollbar
                  direction="horizontal"
                  defaultActiveTab={0}
                />
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <Row className="mb-4">
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">{t("VISNINGER")}</h4>
                <LineGraph
                  useGraphQuery={useSponsorReach}
                  queryParams={graphParams}
                  applyCurrencyConversion={false}
                />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Sponsorverdi")} ({selectedCurrency.currency})
                </h4>
                <LineGraph
                  useGraphQuery={useSponsorValue}
                  queryParams={graphParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">{t("Visninger per kanal")}</h4>
                <LineGraph
                  useGraphQuery={useSponsorDividedReach}
                  queryParams={graphParams}
                  applyCurrencyConversion={false}
                />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Sponsorverdi per kanal")} ({selectedCurrency.currency})
                  <InfoTooltip
                        tooltip={t(
                          "Adj: The Adjusted value for press-mentions is adjusted by the actual size of the logo found within each picture, ranging on a scale from tiny( 50% value) to large (100% value), OTS: The Original value for press-mentions is the value calculated by the system without any adjustments."
                        )}
                      />
                </h4>
                <LineGraph
                  useGraphQuery={useSponsorDividedValue}
                  queryParams={graphParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* With tracked-accounts these show Earned and Tracked only, as on DashboardSponsorPA */}
        {trackedAccountsEnabled && (
          <Row className="mb-4">
            <Col sm={12} md={6} className="mb-4 mb-xl-0">
              <Card className="mini-stat bg-card text-white">
                <CardBody>
                  <h4 className="card-title mb-4">{t("Engasjement per kanal")}</h4>
                  <LineGraph
                    useGraphQuery={useSponsorDividedEngagement}
                    queryParams={graphParams}
                    applyCurrencyConversion={false}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col sm={12} md={6} className="mb-4 mb-xl-0">
              <Card className="mini-stat bg-card text-white">
                <CardBody>
                  <h4 className="card-title mb-4">
                    {t("Engasjementsverdi per kanal")} ({selectedCurrency.currency})
                  </h4>
                  <LineGraph
                    useGraphQuery={useSponsorDividedEngagementValue}
                    queryParams={graphParams}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* Press and TV should not be a part of this. Removing it since most clubs dont have data for instagram/facebook */}
        {/* <Row className="mb-4">
          <Col sm={12} md={6}>
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">{t("Engasjement per kanal")}</h4>
                <LineGraph
                  useGraphQuery={useSponsorDividedEngagement}
                  queryParams={[params.sponsorObjectId]}
                  defaultActiveTab={0}
                />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6}>
            <Card className="mini-stat bg-card text-white">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Engasjementsverdi per kanal")} ({selectedCurrency.currency})
                </h4>
                <LineGraph
                  useGraphQuery={useSponsorDividedEngagementValue}
                  queryParams={[params.sponsorObjectId]}
                  defaultActiveTab={0}
                />
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <Row className="mb-4">
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
          {showLogoDetection ? (
            <Card className="mini-stat bg-card text-white h-100">
              <CardBody>
                <h4 className="card-title mb-4">{t("TV Exposure")}</h4>
                <LogoDetectionStatsChart sponsorObjectId={params.sponsorObjectId}/>
              </CardBody>
            </Card>
          )
        :
          (
            <Card className="mini-stat bg-card text-white h-100">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Sponsorverdi per TV-kanal")} ({selectedCurrency.currency})
                </h4>
                <LineGraph
                  useGraphQuery={useSponsorStationDividedValue}
                  defaultActiveTab={0}
                  queryParams={[params.sponsorObjectId]}
                />
              </CardBody>
            </Card>
          )
        }
          </Col>
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white h-100">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t("Sponsorverdi per medie")} ({selectedCurrency.currency})
                </h4>
                <SponsorSourceDividedValueChart
                  sponsorObjectId={params.sponsorObjectId}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white h-100">
              <CardBody>
                <h4 className="card-title mb-4">{t("Eksponeringer")}</h4>
                <SponsorLogoStatsChart
                  defaultActiveTab={1}
                  sponsorObjectId={params.sponsorObjectId}
                />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} md={6} className="mb-4 mb-xl-0">
            <Card className="mini-stat bg-card text-white h-100">
              <CardBody>
                <h4 className="card-title mb-4">{t("TV seere")}</h4>
                <BarGraph
                  useGraphQuery={useSponsorTvDiveded}
                  queryParams={[params.sponsorObjectId]}
                  scrollbar
                  direction="horizontal"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <TrackedAccountPosts sponsorObjectId={params.sponsorObjectId} />
        <Row className='mb-4'>
          <Col md={12}>
            <Card className="mini-stat bg-card text-white h-100">
              <CardBody>
                <h4 className="card-title mb-4">
                  {t('Ex. brand detections')}
                </h4>
                <ImageDetectionGrid data={imageDetection.data} isLoading={imageDetection.isLoading} isRefetching={imageDetection.isRefetching} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {hasActiveSocialAccounts && (
          <>
            <Row className="mb-4">
              <Col md={12}>
                <BestSocialMediaPostBubbles />
              </Col>
            </Row>
            {/* Tracked account posts replace the tenant's own best and weakest posts */}
            {!trackedAccountsEnabled && (
              <>
                <Row>
                  <Col md={12} className="mb-4">
                    <PerformingSocialMediaPosts type="BESTE" />
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="mb-4">
                    <PerformingSocialMediaPosts type="SVAKESTE" />
                  </Col>
                </Row>
              </>
            )}
            <Row>
              <Col md={12} className="mb-4">
                <PerformingSocialMediaMentions />
              </Col>
            </Row>
            <Row>
              <Col md={12} className="mb-4">
                <PerformingSocialMediaTagged />
              </Col>
            </Row>
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(DashboardSponsor);
